import { render, staticRenderFns } from "./ITagList.vue?vue&type=template&id=2a75a067&scoped=true&"
import script from "./ITagList.vue?vue&type=script&lang=js&"
export * from "./ITagList.vue?vue&type=script&lang=js&"
import style0 from "./ITagList.vue?vue&type=style&index=0&id=2a75a067&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a75a067",
  null
  
)

export default component.exports